import { module } from 'angular';
import templateBuilderQrDisplay from './builder/display.html';
import templateBuilderQrApi from './builder/api.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/qr/display.html', templateBuilderQrDisplay);
	$templateCache.put('kform/components/qr/api.html', templateBuilderQrApi);
});
